
import { defineComponent } from "vue";

export default defineComponent({
  name: "AddEmoji",
  methods: {
    addEmoji(type: string) {
      this.$emit("addEmoji", type);
    }
  }
});
